import React from "react";
import PastYears from "./years";

export function importAll(r: any) {
  return r.keys().map(r);
}

const images = importAll(
  require.context("../images/dresses", false, /\.(png|jpe?g|svg)$/)
);

function Dresses() {
  return (
    <div className="center-box">
      <div className="dress-background center-box small-rotate home">
        <div className="dress-container spaced-and-center-box">
          {images.map((image: any, index: any) => (
            <img
              key={index}
              src={image}
              alt={`Image ${index + 1}`}
              className="dress-image"
            />
          ))}
        </div>
      </div>
      <div />
      <div className="small-rotate white home-layer-up">
        <PastYears />
      </div>
    </div>
  );
}

export default Dresses;
